/** Extract TCFE (CFE type code) from standalone DGI CAE XML (root CAE → DA → TCFE). */

const CAE_NS = "http://cfe.dgi.gub.uy";

function textContent(el: Element | null): string {
  if (!el) return "";
  return (el.textContent ?? "").trim();
}

function firstByLocalName(parent: Element, localName: string): Element | null {
  const byNs = parent.getElementsByTagNameNS(CAE_NS, localName);
  if (byNs.length > 0) return byNs[0];
  const descendants = parent.getElementsByTagName("*");
  for (let i = 0; i < descendants.length; i++) {
    const el = descendants[i];
    if (el.localName === localName) return el;
  }
  return null;
}

/**
 * @returns Normalized TCFE string (e.g. "101") or null if not a valid CAE XML / missing TCFE.
 */
export function parseCaeXmlCfeTypeFromString(xml: string): string | null {
  const doc = new DOMParser().parseFromString(xml, "application/xml");
  if (doc.querySelector("parsererror")) {
    return null;
  }
  const root = doc.documentElement;
  if (!root) return null;
  const rootLocal = root.localName ?? "";
  if (rootLocal !== "CAE") {
    return null;
  }
  const da = firstByLocalName(root, "DA");
  if (!da) return null;
  const tcfe = firstByLocalName(da, "TCFE");
  const raw = textContent(tcfe);
  if (!raw) return null;
  return raw.replace(/\s/g, "");
}
